import React, { useState, useEffect } from "react";
import Post from "./Post.jsx";
import { t } from "../i18n";

const PostingList = ({ refresh, posts, error, type, loadPosts }) => {
  const [blockedPosts, setBlockedPosts] = useState([]);
  const currentUserID = parseInt(sessionStorage.getItem("user"));
  const token = sessionStorage.getItem("token");

  useEffect(() => {
    const fetchBlockedPosts = () => {
      fetch(`${process.env.REACT_APP_API_PATH}/users/${currentUserID}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          const blocked = result.attributes?.blockedPosts || [];
          setBlockedPosts(blocked);
        })
        .catch((error) => console.error("Error fetching blocked posts:", error));
    };
    if (token && currentUserID) {
      fetchBlockedPosts();
    }
  }, [currentUserID, token, refresh]);

  if (!sessionStorage.getItem("token")) {
    return <div>{t("please_log_in")}</div>;
  } else if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!posts) {
    return <div>{t("loading")}</div>;
  } else if (posts.length > 0) {
    const filteredPosts = posts.filter((post) => !blockedPosts.includes(post.id));
    return (
      <div className="posts">
        {filteredPosts.map((post) => (
          <Post
            key={post.id}
            post={post}
            type={type}
            loadPosts={loadPosts}
          />
        ))}
      </div>
    );
  }
};

export default PostingList;